export const BASE_URL = 'https://www.xn----ctbffpbn9bw.xn--p1ai/api/v1';

export const BASE_URL_IMG = 'https://www.xn----ctbffpbn9bw.xn--p1ai';
